import React from 'react'

function Nav(props){
    return (
        <div className='nav'>
            <a href='#work' className='work'>WORK</a>
            <a href='#bio' className='about'>ABOUT</a>
            <a href='#contact' className='contact'>CONTACT</a>
        </div>
    )
}

export default Nav